<!-- yes-no.component.html -->
<div class="yes-no">
  <div class="options">
    <div data-testid="yes-no-yes" class="option" (click)="toggle(true)" [ngClass]="{'selected': value === true}">Yes</div>
    <div data-testid="yes-no-no" class="option" (click)="toggle(false)" [ngClass]="{'selected': value === false}">No</div>
  </div>
  @if (error) {
    <div class="error">Please select</div>
  }
</div>
